import React from 'react';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  background-color: #f8f9fa;
  padding: 1.5rem;
  text-align: center;
  margin-top: 2rem;
  border-top: 1px solid #e9ecef;
`;

const Footer = () => {
  return (
    <FooterContainer>
      <p>&copy; {new Date().getFullYear()} Linx Lab. All rights reserved.</p>
    </FooterContainer>
  );
};

export default Footer;
